import { userService } from "../services";
import config from "../config/config";

export const ExpenseListAction = {
  fetchExpenseList,
  fetchExpenseType,
  fetchExpensSataus,
  ShowApprover,
  exportExpenseExcel,
};

async function fetchExpenseList(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.expenseListGet}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
async function fetchExpensSataus(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.expensestatus}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      // alert(response.data.message);
      return null;
    }
  } catch (error) {
    alert(error);
    console.log("error", error);
    return null;
  }
}

async function fetchExpenseType() {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.expenseType}`;
    const response = await userService.get(apiEndpoint);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function ShowApprover(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.showApprover}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function exportExpenseExcel(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.exportExpenseExcel}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
